import styled from 'foundations-theming/utils';
/**
 * Has the default styles for all property values in the UI.
 * Every custom [Type]PropertyValue component should render this to wrap the value of
 * a CRM object property.
 */
const StyledValue = styled.dd.attrs({
  'data-test-id': 'property-value'
}).withConfig({
  displayName: "StyledValue"
})(["color:", ";font-size:14px;line-height:20px;margin:0;width:", ";"], ({
  theme
}) => theme.color['text-core-default'], ({
  width
}) => width || '100%');
export default StyledValue;